/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var UnifiedPrivacy;
(function (UnifiedPrivacy) {
    let unified_privacy;
    (function (unified_privacy) {
        unified_privacy["OPEN"] = "open";
        unified_privacy["CLOSED"] = "closed";
    })(unified_privacy = UnifiedPrivacy.unified_privacy || (UnifiedPrivacy.unified_privacy = {}));
})(UnifiedPrivacy || (UnifiedPrivacy = {}));
